export default __webpack_public_path__ + "static/media/Gruesome_3.101da777.jpg";